export function GetHeaders(value) {
  switch (value) {
    case "Credit clients":
      return "Clientes a crédito";
    case "Sales projection":
      return "Proyección de ventas";
    case "Partner lending":
      return "Aportes / Préstamos socios";
    case "Pending checks":
      return "Cheques por cobrar";
    case "OTHER_INCOME":
      return "Otros ingresos";
    case "Other incomes":
      return "Otras fuentes";
    case "TOTAL_INCOME":
      return "Ingresos";
    case "Fees":
      return "Honorarios";
    case "Taxes":
      return "Imposiciones";
    case "Salaries":
      return "Sueldos";
    case "Expense report":
      return "Rendiciones";
    case "HUMAN_RESOURCES_EXPENSES":
      return "Gastos RRHH";
    case "Rent":
      return "Arriendos";
    case "trade_credit":
      return "Cuotas de crédito";
    case "Services":
      return "GGCC y servicios generales";
    case "Checks":
      return "Cheques por pagar";
    case "Outsourcing backoffice":
      return "Outsourcing backoffice";
    case "Other providers":
      return "Otros proveedores";
    case "Operational providers":
      return "Proveedores operacionales";
    case "Administration providers":
      return "Proveedores administración";
    case "PROVIDERS_TO_PAY":
      return "Proveedores por pagar";
    case "Overcharge line":
      return "Línea de sobregiro";
    case "Credit letters":
      return "Cartas de crédito";
    case "Withdrawals":
      return "Retiros / devoluciones socios";
    case "FINANCING":
      return "Financiamiento";
    case "Foreign providers":
      return "Proveedores extranjeros";
    case "Imports":
      return "Prov. importación / Agencia aduana";
    case "F-29":
      return "Declaración F-29 IVA";
    case "F-29 postponed":
      return "Declaración F-29 Postergado";
    case "F-22":
      return "Declaración F-22 Renta";
    case "F-50":
      return "Declaración F-50";
    // case "IMPORTATIONS_AND_TAXES":
    //   return "Importaciones e impuestos";
    case "IMPORTS":
      return "Importaciones";
    case "TAXES":
      return "Impuestos";
    case "outflows":
      return "Egresos totales";
    case "inflows":
      return "Ingresos totales";
    case "netInflow":
      return "Variación de caja";
    case "initialBalance":
      return "Saldo inicial";
    case "closingBalance":
      return "Saldo final";
    case "Credit cards":
      return "Tarjeta de crédito";
    case "Key Providers":
      return "Proveedores clave";
    case "Financial Instruments":
      return "Instrumentos Financieros";
    case "Trade agreements":
      return "Acuerdos Comerciales";
    case "comex":
        return "Comex";
    case "bullet":
      return "Bullet";
    default:
      return value.replaceAll("_", " ");
  }
}
